// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2RG0g","gradient":"style_gradient__2TYnX"};